import { useEffect, useRef } from 'react';
import { onEffect } from './emitter';
import type { CopilotEffectType, EffectPayloads } from './types';

/**
 * Subscribe to a copilot effect for the lifetime of the component. The handler
 * is held in a ref so re-renders don't churn the subscription.
 */
export function useCopilotEffect<T extends CopilotEffectType>(
  type: T,
  handler: (payload: EffectPayloads[T]) => void
): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(
    () => onEffect(type, (payload) => handlerRef.current(payload)),
    [type]
  );
}
